import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "System Maintenance", -1)
const _hoisted_2 = { class: "form-horizontal" }
const _hoisted_3 = { class: "card-footer" }
const _hoisted_4 = { class: "col text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!
  const _component_app_card = _resolveComponent("app-card")!
  const _component_app_date_time_picker = _resolveComponent("app-date-time-picker")!
  const _component_app_form_row = _resolveComponent("app-form-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_app_card, { classes: "mx-auto" }, {
      default: _withCtx(() => [
        (_ctx.model.isMaintained)
          ? (_openBlock(), _createBlock(_component_app_button, {
              key: 0,
              name: "Exit Maintenance",
              icon: "fa-child",
              theme: "info",
              onClick: _ctx.actions.exitMaintenance
            }, null, 8, ["onClick"]))
          : (_openBlock(), _createBlock(_component_app_button, {
              key: 1,
              name: "Enter Maintenance",
              icon: "fa-bed",
              theme: "danger",
              onClick: _ctx.actions.enterMaintenance
            }, null, 8, ["onClick"]))
      ]),
      _: 1
    }),
    _createVNode(_component_app_card, { class: "col mx-auto" }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_2, [
          _createVNode(_component_app_form_row, { label: "Start Time" }, {
            default: _withCtx(() => [
              _createVNode(_component_app_date_time_picker, {
                modelValue: _ctx.model.startTime,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.startTime) = $event)),
                validations: _ctx.v$.startTime,
                disabled: _ctx.model.isMaintained && _ctx.model.lastStartTime
              }, null, 8, ["modelValue", "validations", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_app_form_row, { label: "End Time" }, {
            default: _withCtx(() => [
              _createVNode(_component_app_date_time_picker, {
                modelValue: _ctx.model.endTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.endTime) = $event)),
                validations: _ctx.v$.endTime
              }, null, 8, ["modelValue", "validations"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_app_button, {
                name: "Notify",
                theme: "info",
                icon: "fa-save",
                onClick: _withModifiers(_ctx.actions.notifyMaintenance, ["prevent"])
              }, null, 8, ["onClick"]),
              (!_ctx.model.isMaintained && _ctx.model.lastStartTime)
                ? (_openBlock(), _createBlock(_component_app_button, {
                    key: 0,
                    name: "Cancel Notify",
                    theme: "danger",
                    icon: "fa-trash-alt",
                    onClick: _withModifiers(_ctx.actions.cancelNotifyMaintenance, ["prevent"])
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}